import { isDefined } from "./isDefined";

export const isNotDefined = <Type>(
  arg: Type | null | undefined,
): arg is null | undefined => !isDefined(arg);
